import { debounce } from "@mongez/reinforcements";
import type { CustomOption } from "core/catalog";
import { useCallback, useMemo } from "react";
import { TextInput } from "~/design-system/components";
import { CustomOptionLabel } from "./CustomOptionLabel";

type TextInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: string) => void;
};

export function TextInputOption({
  customOption,
  onChange,
}: TextInputOptionProps) {
  const handleChange = useCallback(
    (value: string) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange],
  );

  const debouncedHandleChange = useMemo(
    () => debounce(handleChange, 500),
    [handleChange],
  );

  return (
    <TextInput
      name={customOption.id}
      label={<CustomOptionLabel customOption={customOption} />}
      placeholder={customOption.description}
      defaultValue={customOption.defaultValue as string}
      onChange={debouncedHandleChange}
      classes={{
        wrapper: "w-full",
        input: "bg-white",
        label: "w-fit",
      }}
    />
  );
}
